import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import Invoice from "../../api/Invoice";
import "../Inventory/createInventory.css";

function EditInvoice() {
  const history = useHistory();
  const [customerName, SetCustomerName] = useState("");
  const [date, SetDate] = useState("");
  const [invoiceNo, SetInvoiceNo] = useState("");
  const [emailID, SetEmailID] = useState("");
  const [mobNo, SetMobNo] = useState("");
  const [billAddress, SetBillAddress] = useState("");
  const [cityName, SetCityName] = useState("");
  const [companyName, SetCompanyName] = useState("");
  const [gstNo, SetGstNo] = useState("");

  const [productName,SetProductName] = useState("");
  const [unitName,SetUnitName] = useState("0");
  const [quantityName,SetQuantityName] = useState(0);
  const [totalAmt,SetTotalAmt] = useState(0);

  const params = useParams();

  useEffect(() => {
    const HandelGetReq = async () => {
      const res = await Invoice.get(`/get-invoice/${params.id}`);
      SetCustomerName(res.data.cName);
      SetDate(res.data.date);
      SetInvoiceNo(res.data.invNo);
      SetEmailID(res.data.email);
      SetMobNo(res.data.mob);
      SetBillAddress(res.data.address);
      SetCityName(res.data.city);
      SetCompanyName(res.data.company);
      SetGstNo(res.data.gst);
      SetProductName(res.data.product);
      SetUnitName(res.data.unit);
      SetQuantityName(res.data.quantity);
      SetTotalAmt(res.data.total);
    }
    HandelGetReq();
  }, [SetCustomerName, SetDate, SetInvoiceNo, SetEmailID, SetMobNo, SetBillAddress, SetCityName, SetCompanyName, SetGstNo, SetProductName, SetUnitName, SetQuantityName, SetTotalAmt, params.id]);


  const {
    handleSubmit,
  } = useForm();
  const onSubmit = async () => {
    history.push("/view-invoice")
    const formdata = {
      "cName": customerName,
      "date": date,
      "invNo": invoiceNo,
      "email": emailID,
      "mob": mobNo,
      "address": billAddress,
      "city": cityName,
      "company": companyName,
      "gst": gstNo,
      "product": productName,
      "unit": unitName,
      "quantity": quantityName,
      "total": totalAmt

    }
    // eslint-disable-next-line
    const res = await Invoice.patch(`/update-invoice/${params.id}`, formdata);
  }

  const onClickHandle = () => {
    window.location.href = "/view-invoice";
  }

  return (
    <div className='main-sec'>
      <div className="upd_section">
        <h3 className='fidoh3'>Edit Invoice</h3>
        <button className='view-customer-btn' onClick={onClickHandle}>View Invoice</button>
        <form className='customer-form' onSubmit={handleSubmit(onSubmit)} >
          <div className='row'>
            <div className='colm'>
              <br /><label className='inv-labels'>Customer Name</label><br />
              <input
                className='input-box'
                type="string"
                name="date"
                value={customerName}
                onChange={(e) => {
                  SetCustomerName(e.target.value);
                }}
              />
            </div>
            <div className='colm'>
              <br /><label className='inv-labels'>Invoice Date</label><br />
              <input
                className='input-box'
                type="date"
                name="date"
                value={date}
                onChange={(e) => {
                  SetDate(e.target.value);
                }}
              />
            </div>
          </div>

          <div className='row'>
            <div className='colm'>
              <br /><label className='inv-labels'>Invoice No</label><br />
              <input
                className='input-box'
                type="string"
                name="date"
                value={invoiceNo}
                onChange={(e) => {
                  SetInvoiceNo(e.target.value);
                }}
              />
            </div>
            <div className='colm'>
              <br /><label className='inv-labels'>Email</label><br />
              <input
                className='input-box'
                type="string"
                name="date"
                value={emailID}
                onChange={(e) => {
                  SetEmailID(e.target.value);
                }}
              />
            </div>
          </div>

          <div className='row'>
            <div className='colm'>
              <br /><label className='inv-labels'>Mobile</label><br />
              <input
                className='input-box'
                type="number"
                name="deptName"
                value={mobNo}
                onChange={(e) => {
                  SetMobNo(e.target.value);
                }}
              />
            </div>

            <div className='colm'>
              <br /><label className='inv-labels'>Billing Address</label><br />
              <input
                className='input-box'
                type="string"
                name="deptName"
                value={billAddress}
                onChange={(e) => {
                  SetBillAddress(e.target.value);
                }}
              />
            </div>
          </div>

          <div className='row'>
            <div className='colm'>
              <br /><label className='inv-labels'>City</label><br />
              <input
                className='input-box'
                type="string"
                name="deptName"
                value={cityName}
                onChange={(e) => {
                  SetCityName(e.target.value);
                }}
              />
            </div>

            <div className='colm'>
              <br /><label className='inv-labels'>Company Name</label><br />
              <input
                className='input-box'
                type="string"
                name="deptName"
                value={companyName}
                onChange={(e) => {
                  SetCompanyName(e.target.value);
                }}
              />
            </div>
          </div>


          <div>
            <br /><label className='inv-labels'>GST Number</label><br />
            <input
              className='input-box'
              type="string"
              name="deptName"
              value={gstNo}
              onChange={(e) => {
                SetGstNo(e.target.value);
              }}
            />
          </div><br />

          <div className='invoice-main-div'>
        <br/><label className='item-label'>Item Description</label><br/>
        <table className="invoice-table">
          <thead>
            <tr className='invoice-thread'>
              {/* <th>Sr. No.</th> */}
		          <th>Product Name</th> 
              <th>Unit Price</th> 
              <th>Quantity</th>      
              <th>Amount</th>   
            </tr>
          </thead>
          <tbody>
            <tr>
           <td>
          <select
            className='invoice-input'
            name ="studentName"
            value = {productName}
            onChange={(e)=>{
              SetProductName(e.target.value);
            }}
          >
            <option value=""> </option>
            <option value="Cement">Cement</option>
            <option value="Sand">Sand</option>
            <option value="Aggregates (6 mm)">Aggregates (6 mm)</option>
            <option value="Aggregates (10 mm)">Aggregates (10 mm)</option>
            <option value="Fly As">Fly As</option>
            <option value="Harder">Harder</option>
            <option value="Colour (Red)">Colour (Red)</option>
            <option value="Colour (Black)">Colour (Black)</option>
            <option value="Colour (Yellow)">Colour (Yellow)</option>
            <option value="Fly Ash Brick (4')">Fly Ash Brick (4')</option>
            <option value="Fly Ash Brick (6')">Fly Ash Brick (6')</option>
            <option value="Chequer Tiles (Flower)">Chequer Tiles (Flower)</option>
            <option value="04 Chequer Tiles (Check Box)">04 Chequer Tiles (Check Box)</option>
            <option value="Chequer Tiles (Diamond)">Chequer Tiles (Diamond)</option>
            <option value="Chequer Tiles (Button)">Chequer Tiles (Button)</option>
         </select>
           </td>

           <td>
            <input 
              className='invoice-input'
              type ="string"
              name ="deptName"
              value = {unitName}
              onChange={(e)=>{
                SetUnitName(e.target.value);
                SetTotalAmt(parseInt(e.target.value) * parseInt(quantityName))
              }}
            />
           </td>

           <td>
            <input 
              className='invoice-input'
              type ="number"
              name ="deptName"
              value = {quantityName}
              onChange={(e)=>{
                SetQuantityName(e.target.value);
                SetTotalAmt(parseInt(unitName) * parseInt(e.target.value))
              }}
            />
           </td>

           <td>
            <input 
              className='invoice-input'
              type ="number"
              name ="deptName"
              value = {totalAmt}
              onChange = {(e)=>{
                SetTotalAmt(parseInt(unitName) * parseInt(quantityName))
              }}
            />
           </td>
           </tr>
          
          <tr>
            <td className='cell-amt'></td>
            <td className='cell-bottom'></td>
            <td>Total Amount &nbsp; = </td>
            <td>{totalAmt}</td>
          </tr>
          <tr>
            <td className='cell-amt'></td>
            <td className='cell-bottom'></td>
            <td>GST (18%) &nbsp;&nbsp;&nbsp; = </td>
            <td>{(totalAmt * (18/100))}</td>
          </tr>
          <tr>
            <td className='cell-amt'></td>
            <td className='cell-bottom'></td>
            <td>Total &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;= </td>
            <td>{totalAmt + (totalAmt * (18/100))}</td>
          </tr>
          </tbody>
        </table>
        </div><br/>

          <input className="subButton" type="submit" value="Submit" />
          <input className="cancelButton" type="button" onClick={() => { history.push("/view-invoice") }} value="Cancel" />
        </form>
      </div>
    </div>
  )
}

export default EditInvoice;    